import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../SF/MaterialIcon';
import StaffContactNumbers from "./StaffContactNumbers";
import css from './ContactMoreOptions.css';

export default class ContactMoreOptions extends React.Component {

    constructor() {
        super();
        this.state = { showMoreOptions: false };
    }

    get otherContactNumbers() {
        return this.state.showMoreOptions ? <StaffContactNumbers mobilePhone={this.props.mobilePhone} videoPhone={this.props.videoPhone}/> : null;
    }

    get icon() {
        return this.state.showMoreOptions ? 'keyboard_arrow_down' : 'keyboard_arrow_right';
    }

    render() {
        return (
            <div className={css['container']}>
                <div className={css['more-options']}>
                    <a onClick={() => this.setState({showMoreOptions: !this.state.showMoreOptions})} aria-label="More Contact Options" tabIndex="0">
                        <Icon icon={this.icon}/>
                        More Options
                    </a>
                </div>
                {this.otherContactNumbers}
            </div>
        );
    }
}

ContactMoreOptions.propTypes = {
    mobilePhone: PropTypes.string,
    videoPhone: PropTypes.string
};
